export const MESSAGES_ROUTE = 'wiadomosci';
